module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/4@2x_3ad3743630f0282da2cca8030ed41b8f.png";